import { render, staticRenderFns } from "./expenseApproval.vue?vue&type=template&id=3e5b1b90&"
import script from "./expenseApproval.vue?vue&type=script&lang=js&"
export * from "./expenseApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports